// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getSearchResults} from '../../shared/repositories';
import {readExcelLayouts} from '../../../shared/action-creators/read-excel-layouts';
import {routerActions} from 'react-router-redux';

/* eslint-disable complexity */

export const updateSearchResults = (query, searchBy) =>

    async (dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const searchResults = await getSearchResults(query, searchBy);

            dispatch({
                data: searchResults,
                type: actions.UPDATE_SEARCH_RESULTS_SUCCESS
            });

            if (searchResults.length === 1 && !searchResults[0].isNonTracked) {

                dispatch(routerActions.replace(`/products/${searchResults[0].pin}`));

            }

            if (searchResults.length) {

                const dateRange = {
                    from: Math.min(...searchResults.map(searchResult => searchResult.registrationDate)),
                    to: Math.max(...searchResults.map(searchResult => searchResult.registrationDate))
                };

                dispatch({
                    dateRange,
                    type: actions.UPDATE_REGISTERED_DATE_RANGE_FACET
                });

            }

            dispatch({
                data: searchResults,
                type: actions.FILTER_PRODUCT_SEARCH_RESULTS
            });

            dispatch({
                type: actions.UPDATE_HAS_SEARCH_RESULTS
            });

            if (!getState().exportToExcel.selectedExcelLayout.productSearch.name) {

                readExcelLayouts('productSearch')(dispatch);

            }

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

/* eslint-enable complexity */



// WEBPACK FOOTER //
// ./src/product/search/action-creators/search.js